import {gql} from "@apollo/client";

export const AddItemGroup = gql`
  mutation AddItemGroup(
    $token: String!
    $groupName: String!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AddItemGroup(
      token: $token
      groupName: $groupName
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const UpdateItemGroup = gql`
  mutation UpdateItemGroup(
    $token: String!
    $itemGrpID: ID!
    $user_details: SubscribedUser!
    $groupName: String!
  ) {
    UpdateItemGroup(
      token: $token
      itemGrpID: $itemGrpID
      user_details: $user_details
      groupName: $groupName
    )
  }
`;

export const DeleteItemGroup = gql`
  mutation DeleteItemGroup(
    $token: String!
    $itemGrpID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteItemGroup(
      token: $token
      itemGrpID: $itemGrpID
      user_details: $user_details
    )
  }
`;

export const AddOrUpdateOrDeleteItemGroupAssoic = gql`
  mutation AddOrUpdateOrDeleteItemGroupAssoic(
    $token: String!
    $customerID: ID!
    $itemGrpID: ID!
    $user_details: SubscribedUser!
    $items: AddOrUpdateOrDeleteItems!
  ) {
    AddOrUpdateOrDeleteItemGroupAssoic(
      token: $token
      customerID: $customerID
      itemGrpID: $itemGrpID
      user_details: $user_details
      items: $items
    )
  }
`;

export const AddItemGroupAssembly = gql`
  mutation AddItemGroupAssembly(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: GroupAssembly!
  ) {
    AddItemGroupAssembly(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateItemGroupAssembly = gql`
  mutation UpdateItemGroupAssembly(
    $token: String!
    $itemGrpAssmbldID: ID!
    $user_details: SubscribedUser!
    $input: UpdateGroupAssembly!
  ) {
    UpdateItemGroupAssembly(
      token: $token
      itemGrpAssmbldID: $itemGrpAssmbldID
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteItemGroupAssembly = gql`
  mutation DeleteItemGroupAssembly(
    $token: String!
    $itemGrpAssmbldID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteItemGroupAssembly(
      token: $token
      itemGrpAssmbldID: $itemGrpAssmbldID
      user_details: $user_details
    )
  }
`;
